let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lkFYZ")).then(() => parcelRequire('7j2k7'));